export const TIMESHEET_STATUS = {
    PENDING: 'pending',

    // client: (re)submitted -> approved, terminal state
    APPROVED: 'approved',

    // system: submitted -> autoapproved (Tuesday), terminal state
    AUTOAPPROVED: 'autoapproved',

    // worker: pending|(re)submitted -> $1, sets worker_confirmed_at field
    CONFIRMED: 'confirm--N/A',

    // system: notapproved|resubmitted -> disputed (Tuesday)
    DISPUTED: 'disputed',

    // client: (re)submitted -> notapproved, sends back for worker review
    NOTAPPROVED: 'notapproved',

    // client: (re)submitted -> rejected, terminal state
    REJECTED: 'rejected',

    // worker: notapproved -> resubmitted, worker sends back to client
    RESUBMITTED: 'resubmitted',

    // system: pending -> submitted (Monday)
    SUBMITTED: 'submitted'
};

export const TIMESHEET_STATUS_LOCKED = [
    TIMESHEET_STATUS.APPROVED,
    TIMESHEET_STATUS.AUTOAPPROVED,
    TIMESHEET_STATUS.DISPUTED,
    TIMESHEET_STATUS.SUBMITTED,
    TIMESHEET_STATUS.RESUBMITTED
];

export const TIMESHEET_STATUS_ADMIN_UNLOCKED = [TIMESHEET_STATUS.SUBMITTED, TIMESHEET_STATUS.RESUBMITTED, TIMESHEET_STATUS.PENDING, TIMESHEET_STATUS.CONFIRMED];

export const TIMESHEET_ACTIONS = {
    VIEW: 'view',
    REVIEW: 'review',
    CONFIRM: 'confirm',
    EDIT: 'edit'
};

export const ALERT_ICONS = {
    paycheck: 'attach_money',
    timesheet: 'access_time',
    i9: 'insert_drive_file',
    job: 'business_center',
    invoice: 'attach_money',
    user: 'perm_identity',
    other: 'notifications'
};



// WEBPACK FOOTER //
// ./src/text/enumerations.js